module.exports = __webpack_public_path__ + "img/sample-mini-01.9f51b41b.jpg";